module.exports = "/src/views/player/help/images/capt1.jpg";